import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingPage = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="textSecondary" mt={2}>
        Loading, please wait...
      </Typography>
    </Box>
  );
};

export default LoadingPage;
